export class MessengerUserRepository {

    static get() {
        return JSON.parse(localStorage.getItem("messenger_user"));
    }

    static delete() {
        return localStorage.removeItem("messenger_user")
    }


    static saveUser(messengerUser) {
        localStorage.setItem("messenger_user", JSON.stringify(messengerUser))
    }


    static saveUserToken(token) {
        localStorage.setItem("pwa_messenger_token", token)
    }

    static getUserToken() {
        return  localStorage.getItem("pwa_messenger_token")
    }
}
